import { createSlice } from "@reduxjs/toolkit";
import { ObjectUrlState } from "../types/objectUrl";

const key = "objectUrl";

const initialState: ObjectUrlState = {
  objectUrls: [],
};

/** slice * */
export const objectUrlSlice = createSlice({
  name: key,
  initialState,
  reducers: {
    addObjectUrl: (state, action) => {
      state.objectUrls = [...state.objectUrls, action.payload];
    },
    addObjectUrls: (state, action) => {
      state.objectUrls = [...state.objectUrls, ...action.payload];
    },
    revokeObjectUrls: (state) => {
      const uniqueUrlsSet = new Set(state.objectUrls);
      const uniqueUrls = Array.from(uniqueUrlsSet.values());
      uniqueUrls.map((url) => {
        URL.revokeObjectURL(url);
      });
      state.objectUrls = [];
    },
  },
});

/** selector * */
// const stateSelector = (state: RootState) => state[key];

// action export
export const { addObjectUrl, addObjectUrls, revokeObjectUrls } =
  objectUrlSlice.actions;
